<template>
  <el-dialog :append-to-body="true" id="certificate-layer" title="正元签电子合同数字证书使用协议" :visible.sync="dialogVisible" width="506px" :center="true">
    <p>声明：</p>
    <p>1. 您应当认真阅读并遵守《数字证书使用协议》（以下简称“本协议”），本协议具有合同效力，当您勾选确认并完成全部注册程序后即成立生效。</p>
    <p>2. 请您务必审慎阅读、充分理解各条款内容，如您对本协议有任何疑问或对任何条款不能准确理解的，请不要进行后续操作。</p>
    <p>3. 您承诺接受并遵守本协议的约定，届时您不可以未阅读本协议内容或未获得北京正元安服科技有限公司对您问询的解答等理由，主张本协议无效，或要求撤销本协议。</p>
    <p>4. 本数字证书使用协议更新日期为2020年7月7日，将于2020年7月7日正式生效。</p>
    <p>一、数字证书服务简介</p>
    <p>1. 北京正元安服科技有限公司（以下简称“正元安服”）与工信部认可的电子认证机构合作，为通过实名认证后的互联网个人或企业颁发数字证书，为互联网个人或企业提供全面的电子签约服务。</p>
    <p>2. 您通过北京正元安服科技有限公司的正元签电子合同平台完成实名认证并使用数字证书获得电子签名信任服务，成为正元签电子签名体系不可分割的部分。</p>
    <p>3. 本协议中的“证书”指个人数字证书或企业数字证书。</p>
    <p>二、名词解释</p>
    <p>1. 用户：</p>
    <p>指从委托正元签电子合同平台从权威第三方数字认证中心获得证书的个人、组织机构。</p>
    <p>2. CA机构：</p>
    <p>工业和信息化部批准的电子认证服务机构和国家密码管理局批准的电子政务电子认证服务机构，遵照《中华人民共和国电子签名法》为用户提供数字证书相关的电子认证服务。</p>
    <p>3. 数字证书：</p>
    <p>是指一段信息，它至少包含了一个名字，标识特定的CA或标识特定的用户，包含了用户的公钥、证书有效期、证书序列号，及CA数字签名。</p>
    <p>4. 证书私钥：</p>
    <p>数字证书包含证书本身和一个密钥对，密钥对的一部分是公钥，另一部分称为私钥。公钥公之于众，谁都可以使用。私钥只有自己知道，一般信息都是由公钥进行加密，相对应的私钥进行解密。</p>
    <p>三、用户的权利和义务</p>
    <p>1. 您应按照正元安服规定的证书申请流程向正元签电子合同平台提供有关资料，并保证所填写的注册信息和所提供的资料的真实性、准确性和完整性，否则正元签电子合同平台或正元安服有权拒绝您的申请请求。在这些信息、资料发生改变时及时通知正元签电子合同平台。如因您故意或过失提供的资料不真实、不完整、不准确或资料改变后未及时通知正元签电子合同平台，造成的损失由用户自己承担。</p>
    <p>2. 您的证书信息在证书有效期限内变更的，应当及时书面告知正元签电子合同平台和正元安服，并终止使用该证书。</p>
    <p>3. 若您为企业用户，您企业分立、合并、解散、注销、宣告破产或倒闭，或被撤销营业执照等主体资格终止的，应于上述情况发生时的5个工作日内通过书面形式告知正元签电子合同平台申请撤销数字证书，并终止使用该证书，否则，因未尽该通知义务给正元安服造成损失的，由您全部赔偿。</p>
    <p>4. 您同意正元签电子合同平台向有关部门和个人核实您的信息。正元签电子合同平台应合法地收集、处理、传递及应用您的资料，按照国家有关规定及本协议的约定予以保密。</p>
    <p>5. 您对证书享有独立的使用权。您使用证书产生的权利，由您享有；您使用证书产生的义务、责任，由您承担。</p>
    <p>6. 您应当妥善保管证书私钥。因您原因致使证书私钥泄露、损毁或者丢失的，损失由您承担。当您收到在正元签电子合同平台设置的签署验证码时，需确保是您本人操作，且对验证码承担保密协议。</p>
    <p>7.当您损害权威第三方电子认证服务机构利益时，须向电子认证服务机构赔偿全部损失。这些情形包括但不限于：</p>
    <p>①您在申请数字证书时没有提供真实、完整、准确信息，或在这些信息变更时未及时通知正元签电子合同平台；</p>
    <p>②您知道自己的私钥已经失密或者可能已经失密而未及时告知有关各方、并终止使用；</p>
    <p>③您有其他过错或未履行本协议的相关约定。</p>
    <p>8.权威第三方电子认证服务机构有权因安全风险因素要求正元签电子合同平台更换您的数字证书。</p>
    <p>9.您申请代码签名证书后，一旦发现如下情况之一时，应当立即向正元签电子合同平台申请吊销此证书：</p>
    <p>①证据表明，此代码签名证书被用于签署可疑代码，包括但不限于病毒，木马，或者其他不恰当的程序。</p>
    <p>②证书中内容不再正确或不再准确。</p>
    <p>③此证书私钥信息已被泄露、丢失，或者其他相关部分已被错误使用。</p>
    <p>10.证书一旦被吊销，用户将不能再使用该证书。</p>
    <p>11.如果权威第三方电子认证服务机构发现了证书的不当使用，或者证书被用于违法甚至犯罪行为，电子认证服务机构有权直接吊销您的证书。</p>
    <p>12.在发现或怀疑由权威第三方电子认证服务机构提供的认证服务造成用户的网上交易信息的泄漏和/或篡改时，您应在3个月内向电子认证服务机构提出争议处理请求并通知有关各方。</p>
    <p>四、证书的使用、更新、吊销</p>
    <p>1.您可以在正元签电子合同平台选择适合您的实名认证方式进行数字证书的申请，获得的证书和证书私钥后，由正元签电子合同托管。证书仅用于正元签电子合同平台电子文件签署，正元签电子合同确保您使用证书和证书密钥制作的的电子签名制作数据专属于您所有并由您控制。</p>
    <p>2.您每次在正元签电子合同平台签署电子文件都将使用您的数字证书。正元签电子合同只有核实了您的签署意愿后，才会依据您的意愿使用数字证书签署电子文件。如果启用了指纹签署或扫脸签署或自动盖章功能，视为您知情并同意每次签署电子文件的行为都使用您的数字证书。</p>
    <p>3.本协议的有效期限为证书的有效期限，证书只能在数字证书有效期限内使用，证书有效期限届满，您需要继续使用的，应当及时办理证书更新手续，本协议有效期限顺延至证书更新期限届满日。在获得您将证书延期的授权前，正元签电子合同不会主动为您更新证书。</p>
    <p>4.证书私钥在证书有效期内损毁、丢失、泄露的，您应当及时申请办理撤销手续，撤销自手续办妥时起生效，撤销生效前发生的损失由您承担。</p>
    <p>5.您知悉证书私钥已经丢失或者可能已经丢失时，应当及时告知正元签电子合同平台，协助完成撤销该证书的工作，并终止使用该证书。</p>
    <p>五、正元签电子合同平台的权利</p>
    <p>您有下列情形之一，正元签电子合同平台有权向第三方机构申请吊销证书并不承担任何责任。由此给正元安服造成损失的，您应当向正元安服承担赔偿责任：</p>
    <p>1. 您向正元签电子合同平台提供的资料或者信息不真实、不完整或者不准确的。</p>
    <p>2. 您证书的信息有变更，未终止使用该证书并通知正元签电子合同平台的。</p>
    <p>3. 您知悉证书私钥已经丢失或者可能已经丢失时，未终止使用该证书并通知正元签电子合同平台的。</p>
    <p>4. 您超过证书的有效期限及应用范围使用证书的。</p>
    <p>5. 您企业分立、合并、解散、注销、宣告破产或倒闭，被撤销营业执照等主体资格终止的。</p>
    <p>6. 您使用证书用于违法、犯罪活动的。</p>
    <p>六、第三方电子认证服务机构的服务、权利、义务、责任限制和免责</p>
    <p>1.第三方电子认证服务机构依法制定《电子认证业务规则》（简称CPS），并公布于第三方电子认证服务机构网站，明确第三方电子认证服务机构数字证书的功能、使用证书各方的权利、义务以及第三方电子认证服务机构的责任范围，本协议的相关条款源自CPS。</p>
    <p>2.在用户通过安全工具使用数字证书对交易信息进行加密和签名的条件下，第三方电子认证服务机构将保证交易信息的保密性、完整性、抗抵赖性。如果发生纠纷，第三方电子认证服务机构将依据不同情形承担下述义务：</p>
    <p>①提供签发用户数字证书的CA证书；</p>
    <p>②提供用户数字证书在交易发生时，在或不在第三方电子认证服务机构发布的数字证书废止列表内的证明；</p>
    <p>③对数字证书、数字签名、时间戳的真实性、有效性进行技术确认。</p>
    <p>3.有下列情形之一的，第三方电子认证服务机构有权撤销所签发的数字证书：</p>
    <p>①用户申请数字证书时，提供的资料不真实；</p>
    <p>②用户未履行本协议约定的义务；</p>
    <p>③用户书面申请撤销数字证书；</p>
    <p>④证书的安全性不能得到保证；</p>
    <p>⑤法律、行政法规规定的其他情况。</p>
    <p>4.第三方电子认证服务机构将对用户申请数字证书时提交的信息进行审核，提供证书生命周期內的相关服务，同时向相关方提供查询服务。第三方电子认证服务机构及其注册机构均有义务保护用户隐私信息安全性。</p>
    <p>5.根据《电子签名法》的规定，如果用户依法使用第三方电子认证服务机构提供的认证服务进行民事活动而遭受损失的，第三方电子认证服务机构将给予相应赔偿，除非第三方电子认证服务机构能够证明其提供的服务是按照《电子签名法》等相关法律法规和第三方电子认证服务机构向主管部门备案的CPS实施的。以下损失不在赔偿之列：</p>
    <p>①任何直接或间接的利润或收入损失、信誉或商誉损害、任何商机或契机损失、失去项目、以及失去或无法使用任何数据、无法使用任何设备、无法使用任何软件；</p>
    <p>②由上述损失相应生成或附带引起的损失或损害。</p>
    <p>6.以下损失第三方电子认证服务机构将不承担责任：</p>
    <p>①非因第三方电子认证服务机构的行为而导致的损失；</p>
    <p>②因不可抗力而导致的损失，如罢工、战争、灾害、恶意代码病毒等。</p>
    <p>7.第三方电子认证服务机构对企业用户申请的数字证书的赔偿上限以各电子认证服务机构的官方说明为准。</p>
    <p>七、免责条款</p>
    <p>1. 因设备故障、电力故障及通讯故障或者电脑病毒、自然灾害等因素造成您损失的，正元签电子合同平台不承担任何责任。</p>
    <p>2. 由于第三方电子认证中心的原因导致证书私钥被破译、窃取，致使您遭受损失的，由第三方电子认证中心向您承担赔偿责任。</p>
    <p>八、协议的终止</p>
    <p>有下列情形之一的，本协议终止：</p>
    <p>1. 您证书期限届满。</p>
    <p>2. 您证书被吊销。</p>
    <p>3. 您向正元签电子合同平台申请终止本协议，平台同意的。</p>
    <p>4. 双方协商终止本协议的。</p>
    <p>5. 依据法律、法规等规定，本协议应当终止的。</p>
    <p>九、争议解决条款</p>
    <p>对任何因履行本协议发生的或与本协议有关的一切争议，双方应首先通过友好协商的方式解决。在争议发生之日起30日内协商无果时，任何一方均有权将争议提交至中国国际经济贸易仲裁委员会北京分会按该会届时有效的仲裁规则仲裁。仲裁地点为北京，仲裁语言为中文。仲裁裁决为最终的，对双方皆具有法律约束力。在本协议仲裁或者争议期间，双方应继续履行本协议其它未被仲裁或者没有争议的条款。</p>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      dialogVisible: false
    }
  }
}
</script>